import { useEffect } from 'react';
import { useTheme } from 'next-themes';

export const useAutoTheme = () => {
  const { setTheme, theme } = useTheme();

  useEffect(() => {
    const updateTheme = () => {
      const now = new Date();
      const hours = now.getHours();
      
      // Horarios para México (considerando zona horaria local del usuario)
      // Día: 6:00 AM - 6:00 PM (18:00)
      // Noche: 6:00 PM - 6:00 AM
      const isDayTime = hours >= 6 && hours < 18;
      const targetTheme = isDayTime ? 'light' : 'dark';
      
      // Solo cambiar si es diferente al tema actual para evitar loops
      if (theme !== targetTheme) {
        setTheme(targetTheme);
        
        // Mostrar notificación sutil del cambio
        console.log(`🌅 Tema cambiado automáticamente a ${isDayTime ? 'día' : 'noche'} (${hours}:00)`);
      }
    };

    // Ejecutar inmediatamente
    updateTheme();

    // Verificar cada minuto si cambió la hora
    const interval = setInterval(updateTheme, 60 * 1000);

    // Verificar cuando el usuario regresa a la pestaña
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        updateTheme();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [setTheme, theme]);

  // Función para obtener información del estado actual
  const getCurrentThemeInfo = () => {
    const now = new Date();
    const hours = now.getHours();
    const isDayTime = hours >= 6 && hours < 18;
    
    return {
      isDayTime,
      currentHour: hours,
      nextChange: isDayTime ? '18:00 (modo noche)' : '06:00 (modo día)',
      currentMode: isDayTime ? 'día' : 'noche'
    };
  };

  return {
    getCurrentThemeInfo,
    theme
  };
};